module.exports = __webpack_public_path__ + "static/img/person.6531614c.png";